import { useNavigate } from "react-router-dom";
import "../styles/home.css";

const TopBar = () => {
  const navigate = useNavigate();

  const handleWarrantyClick = () => {
    window.scrollTo(0, 0);
    navigate("/warranty", { state: { _w: Date.now() } });
  };

  return (
    <div className="container p-0">
      <div className="topbar">
        {/* <div>📞 Call us: +91 9100039893</div> */}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <div
            onClick={handleWarrantyClick}
            style={{ cursor: "pointer" }}
          >
            Warranty
          </div> */}

          <div> 📞 Call us: +91 9100039893</div><div>   Mon–Sat: 11:00AM – 6:00PM</div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .topbar {
            flex-direction: column;
            gap: 4px;
            font-size: 10px;
            padding: 6px 10px;
            text-align: center;
          }

          .container {
            max-width: 1400px;
          }

          .topbar div {
            width: 100%;
            line-height: 1.4;
          }
        }
      `}</style>
    </div>
  );
};

export default TopBar;